import React, { createContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'clarity2work-theme';

export const ThemeContext = createContext({
  theme: 'light',
  setTheme: function () {},
});

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(function () {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'light';
    } catch {
      return 'light';
    }
  });

  useEffect(
    function () {
      document.documentElement.setAttribute('data-theme', theme);
      try {
        localStorage.setItem(STORAGE_KEY, theme);
      } catch (_) {}
    },
    [theme]
  );

  function setTheme(next) {
    setThemeState(function (prev) {
      const value = typeof next === 'function' ? next(prev) : next;
      return value === 'dark' ? 'dark' : 'light';
    });
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
